import React, { useState } from 'react';
import { TextField } from '@mui/material';

import { AddressAutofill } from '@mapbox/search-js-react';

import {
  ADDRESS_HEADER,
  STREET_ADDRESS,
  APT_UNIT,
  CITY,
  STATE,
  ZIP_CODE,
  COUNTRY,
  USA,
  streetRequired,
  cityRequired,
  zipcodeRequired,
} from '../../constants/Profile/editAddress';

import './EditAddress.css';

export const EditAddress = ({ address = {}, onAddressChange, register, errors, setValue }) => {
  const handleChange = (props) => {
    const addressUpdate = [
      { name: STREET_ADDRESS, value: props.address_line1 ?? '' },
      { name: APT_UNIT, value: props.address_Line2 ?? '' },
      { name: STATE, value: props.region ?? '' },
      { name: CITY, value: props.place ?? '' },
      { name: ZIP_CODE, value: props.postcode ?? '' },
      { name: ZIP_CODE, value: props.postcode ?? '' },
    ];
    addressUpdate.forEach(({ name, value }) => {
      onAddressChange({ name, value });
      setValue(name, value);
    });
  };

  const handleAutChange = (e) => {
    const props = e.features?.[0].properties || {};
    handleChange(props);
  };
  return (
    <div className="edit-address-form">
      <div className="address-header-text">{ADDRESS_HEADER}</div>

      <div className="street-address-field-wrapper">
        <AddressAutofill
          accessToken={process.env.REACT_APP_ADDRESS_TOKEN}
          onRetrieve={handleAutChange}
        >
          <label>{STREET_ADDRESS}</label> <br />
          <TextField
            id="inputfield"
            placeholder={STREET_ADDRESS}
            name={STREET_ADDRESS}
            fullWidth
            autoComplete="address-line1"
            value={address[STREET_ADDRESS] ?? ''}
            {...register(STREET_ADDRESS, {
              required: streetRequired,
            })}
            onChange={(e) => onAddressChange({ name: STREET_ADDRESS, value: e.target.value })}
            variant="outlined"
          />
          {errors[STREET_ADDRESS] && (
            <p className="error-message">{errors[STREET_ADDRESS].message}</p>
          )}
        </AddressAutofill>
      </div>

      <div className="apt-city-wrapper">
        <div className="apt-field-wrapper">
          <label>{APT_UNIT}</label> <br />
          <TextField
            id="inputfield"
            placeholder={APT_UNIT}
            name={APT_UNIT}
            fullWidth
            autoComplete="address-line2"
            value={address[APT_UNIT] ?? ''}
            onChange={(e) => onAddressChange({ name: APT_UNIT, value: e.target.value })}
            variant="outlined"
          />
        </div>
        <div className="city-field-wrapper">
          <label>{CITY}</label> <br />
          <TextField
            id="inputfield"
            placeholder={CITY}
            name={CITY}
            fullWidth
            autoComplete="address-level2"
            value={address[CITY]}
            {...register(CITY, {
              required: cityRequired,
            })}
            onChange={(e) => onAddressChange({ name: CITY, value: e.target.value })}
            variant="outlined"
          />
          {errors[CITY] && <p className="error-message">{errors[CITY].message}</p>}
        </div>
      </div>

      <div className="state-zip-wrapper">
        <div className="state-field-wrapper">
          <label>{STATE}</label> <br />
          <TextField
            id="inputfield"
            placeholder={STATE}
            name={STATE}
            fullWidth
            autoComplete="region"
            value={address[STATE]}
            onChange={(e) => onAddressChange({ name: STATE, value: e.target.value })}
            variant="outlined"
          />
        </div>
        <div className="zip-code-field-wrapper">
          <label>{ZIP_CODE}</label> <br />
          <TextField
            id="inputfield"
            placeholder={ZIP_CODE}
            name={ZIP_CODE}
            fullWidth
            autoComplete="postal-code"
            value={address[ZIP_CODE]}
            {...register(ZIP_CODE, {
              required: zipcodeRequired,
            })}
            onChange={(e) => onAddressChange({ name: ZIP_CODE, value: e.target.value })}
            variant="outlined"
          />
          {errors[ZIP_CODE] && <p className="error-message">{errors[ZIP_CODE].message}</p>}
        </div>
      </div>

      <div className="country-field-wrapper">
        <label>{COUNTRY}</label> <br />
        <TextField
          id="inputfield"
          placeholder={COUNTRY}
          name={COUNTRY}
          fullWidth
          autoComplete="country"
          value={USA}
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
          variant="outlined"
        />
      </div>
    </div>
  );
};
